import { Toaster as Sonner } from "sonner";
import { CheckCircle2, CircleAlert, Info, Loader2, X } from "lucide-react";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      position="top-right"
      closeButton
      expand
      visibleToasts={5}
      gap={10}
      offset={{ top: 16, right: 16 }}
      duration={4200}
      className="toaster group"
      icons={{
        success: <CheckCircle2 className="h-4 w-4 text-emerald-400" />,
        error: <CircleAlert className="h-4 w-4 text-red-400" />,
        info: <Info className="h-4 w-4 text-sky-400" />,
        warning: <CircleAlert className="h-4 w-4 text-amber-400" />,
        loading: <Loader2 className="h-4 w-4 animate-spin text-primary" />,
        close: <X className="h-3.5 w-3.5" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast autotubber-toast group-[.toaster]:pointer-events-auto",
          title: "autotubber-toast-title",
          description: "autotubber-toast-description",
          actionButton: "autotubber-toast-action",
          cancelButton: "autotubber-toast-cancel",
          closeButton: "autotubber-toast-close",
          success: "autotubber-toast-success",
          error: "autotubber-toast-error",
          info: "autotubber-toast-info",
          warning: "autotubber-toast-warning",
          loading: "autotubber-toast-loading",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
